/*
 * @Description: 特性开关控件
 * @Author: jiawei
 * @Date: 2022-04-25 16:58:50
 * @Last Modified by: zhangh
 * @Last Modified time: 2023-01-05 17:22:01
 */
import React, { ReactNode, memo } from 'react';
import { isFunction } from 'lodash';
import { useDevopsSwitch } from '@hooks';

interface Props {
  /**
   * 特性开关关闭 显示元素
   * @example
   * <DevopsSwitch defaultDom='开关关闭展示的内容' code="开关key">
   *   开关打开展示的内容
   * </DevopsSwitch>
   */
  defaultDom?: ReactNode;
  /**
   * 特性开关打开 显示元素
   */
  children?: ReactNode;
  /**
   * 特性开关key
   * @example
   * code="xxxx"
   */
  code: string;
  /**
   * 特性开关项目
   * @default MES-FE-PC
   * @example
   * project="MES-FE-PC"
   */
  project?: string;
  /**
   * 严格模式，开启严格模式后，只有开关返回值之后才会返回元素
   * @default false
   */
  isStrict?: boolean;
  /**
   * 特性开关打开 渲染元素的方法
   * @return ReactNode
   */
  render?: () => ReactNode;
}

export default memo(({ code, children, defaultDom = null, project, isStrict, render }: Props) => {
  const switchStatus = useDevopsSwitch(code, project);

  /** 判断渲染传进来的 dom */
  if (switchStatus) {
    if (children) {
      return <>{children}</>;
    }

    if (isFunction(render)) {
      return <>{render()}</>;
    }

    return null;
  }

  // 严格模式
  if (isStrict) {
    if (switchStatus === false) {
      return <>{defaultDom}</>;
    }
    return null;
  }

  return <>{defaultDom}</>;
});
